/**
 * Редирект на страницу входа при истечении сессии (401/403 или пустая сессия).
 * Сохраняет текущий URL в next для возврата после логина.
 */
export default function redirectToLogin() {
  const next = encodeURIComponent(window.location.href);
  window.location.replace(`/login/?next=${next}`);
}
